import LoadingBackdrop from '@/components/Loading/LoadingBackdrop'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { IPermissionProps } from '@/types/shared'
import React from 'react'
import toast from 'react-hot-toast'
import { useParams } from 'react-router-dom'
import { getVCardByID } from '../../services'
import { PageVCardCreate } from '../Create'

import { QUERY_KEYS } from '@/constants/reactQueryKeys'

const VCardUpdate: React.FC<IPermissionProps> = () => {
    const { id } = useParams<{ id: string }>()
    const { data, refetch, renderState } = useQueryWithHandler({
        queryKey: [QUERY_KEYS.VCARDS, id],
        loadingComponent: <LoadingBackdrop />,
        queryFn: async () => {
            try {
                const response = await getVCardByID(Number(id))
                return response
            } catch (error) {
                toast.error('' + error)
            }
        },
    })
    const stateComponent = renderState()
    if (stateComponent) return stateComponent
    return (
        <>
            {data && (
                <PageVCardCreate
                    pageType="update"
                    vCard={data?.result}
                    refetchData={refetch}
                />
            )}
        </>
    )
}

export default VCardUpdate
